import { Chip, Grid, IconButton } from '@material-ui/core';
import { Event, Group, Mail, Close } from '@material-ui/icons';
import { getClassesById, responseInvitationAffiliation } from '@webapps/business';
import { useQuery, useMutation, useToast, Button, Modal } from '@webapps/reactjs-tech-components';
import { useStyles } from '@webapps/styles';
import { useState, useEffect } from 'react'
import { FormattedDate } from 'react-intl';
import CancelIcon from '@material-ui/icons/Cancel';

const CandidatsCard = ({ groupId, inviteDate, status, student, id, refetch }) => {
  const {
    classes,
    css,
    cx,
    global,
    theme: { spacing },
  } = useStyles(styles);
  const [open, setOpen] = useState(false);
  const [inviteId, setInviteId] = useState('');
  const { addToast } = useToast();

  const {
    error: errorAffiliateAction,
    isSuccess: isSuccessAffiliateAction,
    mutate: mutateSetAffiliateAction,
  } = useMutation(responseInvitationAffiliation);

  const cancelAffiliate = async () => {
    await mutateSetAffiliateAction({
      action: 'canceled',
      id: inviteId,
    });
  };

  useEffect(() => {
    if (errorAffiliateAction) {
      addToast({
        status: 'error',
        message: "Une erreur est survenu lors de l'annulation de l'invitation",
      });
    }
    if (isSuccessAffiliateAction) {
      addToast({
        status: 'success',
        message: 'Invitation annulée avec succès',
      });
      refetch();
    }
  }, [isSuccessAffiliateAction, errorAffiliateAction]);


  return (
    <Grid item xs={12} md={4} style={{ padding: spacing(2.5, 2.5, 0, 0) }}>
      <div>
        <div style={{ padding: 20, borderRadius: 10, backgroundColor: '#FFF'}} >
          <div style={{ position: 'relative' }}>
            <div>
              <div className={classes.infoCandidat}>
                <div
                  className={css({
                    display: 'flex',
                    flexDirection: 'column',
                    width: '100%',
                  })}
                > <div className={cx(global.infoText, classes.address)}>
                    <Mail className={global.infoIcon} />
                    {student}
                    {status === 'pending' && (
                      <IconButton
                        className={css({
                          background: '#F3F7FF',
                          border: '1px solid #C0D9FF',
                          width: '30px',
                          height: '30px',
                          position: 'absolute',
                          cursor: 'pointer',
                          right: '0'
                        })}
                        value={id}
                        data-value={id}
                        onClick={(e) => { setOpen(true); e.target.parentNode.getAttribute('data-value') ? setInviteId(e.target.parentNode.getAttribute('data-value')) : setInviteId(e.target.dataset.value); }}
                        size="small">
                        <Close value={id} data-value={id} style={{ color: '#5A6DA1', fontSize: '15.00px' }} />
                      </IconButton>
                    )}
                  </div>
                  <div className={cx(global.infoText, classes.address)}>
                    <Group className={global.infoIcon} />
                    <ClassroomName id={groupId} />
                  </div>
                </div>
              </div>
            </div>
            <div>
              <div className={cx(global.infoText, classes.address)} >
                <Event className={global.infoIcon} />
                <FormattedDate
                  day="numeric"
                  month="numeric"
                  value={inviteDate}
                  year="numeric" /></div>
              <div className={cx(global.infoText, classes.address)} style={{ marginTop: spacing(1) }} >
                {status === 'pending' && (
                  <Chip
                    classes={{
                      colorPrimary: css({
                        background: '#FAE8D7 ',
                        color: '#FA8100',
                      }),
                    }}
                    className={classes.chip}
                    color="primary"
                    label="En attente"
                    size="small"
                  />
                )}
                {status === 'CANCELED' && (
                  <Chip
                    classes={{
                      colorPrimary: css({
                        background: '#fbd3d5',
                        color: '#F50057',
                      }),
                    }}
                    className={classes.chip}
                    color="primary"
                    label="Annulé"
                    size="small"
                  />
                )}
                {status === 'REJECTED' && (
                  <Chip
                    classes={{
                      colorPrimary: css({
                        background: '#fbd3d5',
                        color: '#F50057',
                      }),
                    }}
                    className={classes.chip}
                    color="primary"
                    label="Refusé"
                    size="small"
                  />
                )}
                {status === 'ACCEPTED' && (
                  <Chip
                    classes={{
                      colorPrimary: css({
                        background: '#DBFAD8',
                        color: '#008000',
                      }),
                    }}
                    className={classes.chip}
                    color="primary"
                    label="Accepté"
                    size="small"
                  />
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
      <Modal
        onCancel={() => setOpen(false)}
        open={open}
        title={'Voulez-vous vraiment annuler cette invitation ?'}
        withStep={false}
      >
        <Button
          className={css({ marginTop: "12px", marginLeft: "auto", marginRight: "auto", display: "block" })}
          color="primary"
          variant="outlined"
          onClick={() => { cancelAffiliate(); setOpen(false) }}
        >Confirmer
        </Button>
      </Modal>
    </Grid>
  )
}

const ClassroomName = ({ id }) => {
  const { data: classroom = {} } = useQuery(getClassesById, {
    key: ['classroom', id],
    variables: { id },
  });

  return <div>{classroom?.label}</div>;
};

const styles = ({ spacing }) => ({
  formations: {
    marginTop: spacing(2),
  },
  infoCandidat: { display: 'flex', alignItems: 'center', width: '100%' },
  tableHead: {
    '&.MuiTableCell-head': {
      color: 'white',
    },
  },
  address: {
    display: 'flex',
    alignItems: 'center',
    marginBottom: spacing(0.5),
  },
  chip: {
    padding: spacing(2.5),
    '@media only screen and (max-width:1920px)': { fontSize: '13.500px' }, '@media only screen and (max-width:1600px)': { fontSize: '13.5000px' },
    fontWeight: 'regular',
    borderRadius: '10.0px',
    '@media only screen and (max-width:768px)': { fontSize: 12, padding: 0, maring: 0 },
  },
});

export default CandidatsCard